import { observer } from 'mobx-react-lite';
import React, { Fragment, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { useStore } from '../../../app/stores/Store';
import TopActionButtons from './TopActionButtons';
import './css/salesOrderDetail.css';
import DocumentHeaderLogo from './DocumentHeaderLogo';
import DocumentHeaderAndAddress from './DocumentHeaderAndAddress';
import DocumentSoldToShipTo from './DocumentSoldToShipTo';
import DocumentCustomerContacts from './DocumentCustomerContacts';
import DocumentShipmentDetails from './DocumentShipmentDetails';
import DocumentItemDetails from './DocumentItemDetails';
import SalesOrderDetailsPlaceHolder from './SalesOrderDetailsPlaceHolder';

const SalesOrderDetail: React.FC = () => {

    const { id } = useParams<{ id: string }>();
    const { salesOrderStore, dataSyncStore } = useStore();
    const { loadSalesOrderByOrderNo, loadingSalesOrder, currentSalesOrder } = salesOrderStore;
    const { syncingSalesOrders } = dataSyncStore;
    useEffect(() => {
        loadSalesOrderByOrderNo(id!);
    }, [loadSalesOrderByOrderNo, id])

    if (currentSalesOrder === null || loadingSalesOrder) {
        return <LoadingComponent />
    }


    return (
        <Fragment>

            <TopActionButtons />

            {syncingSalesOrders ? (
                <div className='invoiceDocument'>
                    <SalesOrderDetailsPlaceHolder />
                </div>
            ) : (
                <div className='invoiceDocument'>
                    <DocumentHeaderLogo />
                    <DocumentHeaderAndAddress />
                    <DocumentSoldToShipTo />
                    <DocumentCustomerContacts />
                    <DocumentShipmentDetails />
                    <DocumentItemDetails />

                </div>

            )}

        </Fragment>
    )
}

export default observer(SalesOrderDetail)
